import React from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import { GuideBanner, type GuidePageBanner } from './GuideBanner';

export type GuidePageShellProps = Readonly<{
  /** Tool backing the guide, which the banner's bookmark and add-task actions act on. */
  toolId: string;
  banner: GuidePageBanner;
  /** The guide's body — `GuideSections` for a sectioned guide, or a guide's own layout. */
  children: React.ReactNode;
}>;

/** The frame shared by every guide landing page: the hero banner above the guide's body. */
export const GuidePageShell: React.FC<GuidePageShellProps> = ({ toolId, banner, children }) => (
  <Box sx={containerSx}>
    <GuideBanner toolId={toolId} banner={banner} />
    {children}
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
  pt: backrs.spacing['spacing-lg'],
  mb: backrs.spacing['spacing-4xl'],
  width: '100%',
});
